import { render, staticRenderFns } from "./tableOtherTax.vue?vue&type=template&id=25ecc55d&scoped=true"
import script from "./tableOtherTax.vue?vue&type=script&lang=js"
export * from "./tableOtherTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ecc55d",
  null
  
)

export default component.exports